import { z } from 'zod';

import { WireSize } from './WireSize';

export const WireSizeRange = {
    validator: z
        .object({
            min: WireSize.validator.nullable().default(null),
            max: WireSize.validator.nullable().default(null),
        })
        .default({}),
};
